/* eslint-disable */
export default {
  notActivated: 'Inactief',
} as const;

// @key: @#@"notActivated"@#@ @source: @#@"Inactive"@#@
